import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import LocationIcon from '@mui/icons-material/PlaceOutlined';
import CameraIcon from '@mui/icons-material/PhotoCameraOutlined';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import { t } from '~/utils/narration';

export default function KycPermissions() {
  return (
    <List sx={{ width: '100%', bgcolor: 'transparent' }}>
      <ListItem sx={{ pl: 0 }}>
        <ListItemAvatar>
          <Avatar sx={{ background: "transparent"}}>
            <CameraIcon sx={{ fill: "#8A8AA3", width: '1.2em', height: '1.2em' }} />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={t({ en: 'Allow camera & mic. permission', hi: 'कैमरा और माइक की अनुमति दें' })}
          secondary={t({ en: 'To capture photos and videos for verification', hi: 'वेरिफ़िकेशन के लिए फ़ोटो और वीडियो लेने हेतु' })}
        />
      </ListItem>
      <ListItem sx={{ pl: 0 }}>
        <ListItemAvatar>
          <Avatar sx={{ background: "transparent"}}>
            <LocationIcon sx={{ fill: "#8A8AA3", width: '1.2em', height: '1.2em' }} />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={t({ en: 'Allow precise location permission', hi: 'सटीक स्थान की अनुमति दें' })}
          secondary={t({ en: 'To obtain the location details where you are completing the KYC.', hi: 'उस स्थान का विवरण प्राप्त करने के लिए जहाँ आप केवाईसी पूरा कर रहे हैं।' })}
        />
      </ListItem>
    </List>
  );
}
